
// Header.js

import React, { useState } from 'react'
import { NavLink, useNavigate } from "react-router-dom";

import '../../styles/navigation/Layout.css';
import Button from '../buttons/Button';
import Logo from '../design/Logo';

import { FaHome } from "react-icons/fa";
import { FiBox } from "react-icons/fi";
import { LuUsers, LuMenu, LuX } from "react-icons/lu";
import { MdMailOutline } from "react-icons/md";

const NAV_LINKS = [
    { to: '/home', label: 'Home', icon: FaHome },
    { to: '/products', label: 'Products', icon: FiBox },
    { to: '/team', label: 'Team', icon: LuUsers },
];

const HeaderMobile = () => {
    const [menuOpen, setMenuOpen] = useState(false);
    const navigate = useNavigate();

    const closeMenu = () => setMenuOpen(false);

    const handleContactClick = () => {
        closeMenu();
        navigate('/contact');
    };

    return (<>
        {/* The flex box the Header Banner */}
        <div className="header-bar-box">
            <div className="header-bar-content">

                {/* Brand section — icon-only mark, left-anchored */}
                <div className="header-bar-inner-box">
                    <Logo variant="icon" size="small" mode="light" />
                </div>

                {/* Menu toggle — swaps between hamburger and close icon */}
                <button
                    className="header-bar-hamburger"
                    onClick={() => setMenuOpen(prev => !prev)}
                    aria-label={menuOpen ? "Close navigation menu" : "Open navigation menu"}
                    aria-expanded={menuOpen}
                >
                    {menuOpen ? <LuX/> : <LuMenu/>}
                </button>

            </div>

            {/* Mobile dropdown menu */}
            <div className={`header-bar-mobile-menu${menuOpen ? ' open' : ''}`}>
                <nav className="header-bar-mobile-links">
                    {NAV_LINKS.map(({ to, label, icon: Icon }) => (
                        <NavLink
                            key={to}
                            to={to}
                            className="header-bar-mobile-button"
                            onClick={closeMenu}
                        >
                            <Icon className="header-bar-mobile-icon"/>
                            <span>{label}</span>
                        </NavLink>
                    ))}
                </nav>

                <div className="header-bar-mobile-contact-container">
                    <Button size="4" onClick={handleContactClick} disabled={false}>
                        <MdMailOutline className="header-bar-mobile-icon"/>
                        <span>Contact Us</span>
                    </Button>
                </div>
            </div>

        </div>
    </>)
}

export default HeaderMobile
